module.exports = __webpack_public_path__ + "img/movement.d4f32deb.svg";